import React, { useState } from 'react';
import ManualTab from './ManualTab';
import AutoTab from './AutoTab';
import RemoveTab from './RemoveTab';
import { Tabs, TabsList, TabsTrigger } from '@libero/core/components/ui/tabs';

export default function App() {
  const [tab, setTab] = useState<'manual' | 'auto' | 'remove'>('manual');

  return (
    <div>
      <div className="px-6 pt-6 max-w-screen-xl mx-auto">
        <Tabs value={tab} onValueChange={(v) => setTab(v as 'manual' | 'auto' | 'remove')}>
          <TabsList>
            <TabsTrigger value="manual">Manuell</TabsTrigger>
            <TabsTrigger value="auto">Auto-Zuordnung</TabsTrigger>
            <TabsTrigger value="remove">Entfernen</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
      {tab === 'manual' ? <ManualTab /> : tab === 'auto' ? <AutoTab /> : <RemoveTab />}
    </div>
  );
}
